module.exports = __webpack_public_path__ + "media/post-listing-block-3-overlay-wide@2x.13199070.png";